"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_store_1 = require("owa-options-store");
var owa_options_store_2 = require("owa-options-store");
var mobx_react_1 = require("mobx-react");
var SearchBox_1 = require("office-ui-fabric-react/lib/SearchBox");
var Callout_1 = require("office-ui-fabric-react/lib/Callout");
var FocusZone_1 = require("office-ui-fabric-react/lib/FocusZone");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var ReactDOM = require("react-dom");
var filterOptions_1 = require("../../utils/filterOptions");
var OptionSearchSuggestion_1 = require("./OptionSearchSuggestion");
var styles = require('./OptionsFull.scss');
var FullOptionSearch = /** @class */ (function (_super) {
    tslib_1.__extends(FullOptionSearch, _super);
    function FullOptionSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSearchBoxKeyDown = function (ev) {
            if (ev.key === 'ArrowDown') {
                _this.suggestionFocusZone.focus();
                ev.stopPropagation();
                ev.preventDefault();
            }
        };
        _this.onFirstOptionKeyDown = function (ev) {
            switch (ev.key) {
                case 'ArrowUp':
                    if (ev.currentTarget.dataset.optionIndex === '0') {
                        _this.searchBox.focus();
                        break;
                    }
                    else {
                        return;
                    }
                case 'Escape':
                    owa_options_store_1.setSearchTerm('');
                    _this.searchBox.focus();
                    break;
                default:
                    // don't stop propagation or prevent default
                    return;
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this.searchBoxRef = function (ref) {
            _this.searchBox = ref;
            _this.searchBoxElement = ReactDOM.findDOMNode(ref);
        };
        _this.suggestionFocusZoneRef = function (ref) {
            _this.suggestionFocusZone = ref;
        };
        return _this;
    }
    FullOptionSearch.prototype.render = function () {
        var _this = this;
        var store = owa_options_store_2.getStore();
        var suggestedOptions = filterOptions_1.default(store.searchTerm);
        var showSuggestions = suggestedOptions && suggestedOptions.length > 0;
        return (React.createElement("div", { onKeyDown: showSuggestions && this.onSearchBoxKeyDown },
            React.createElement(SearchBox_1.SearchBox, { componentRef: this.searchBoxRef, labelText: owa_options_strings_1.default.optionsFull_searchPlaceholder, className: styles.searchBox, value: store.searchTerm, onChanged: owa_options_store_1.setSearchTerm }),
            showSuggestions && (React.createElement(Callout_1.Callout, { target: this.searchBoxElement, isBeakVisible: false, className: styles.suggestionCallout },
                React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.vertical, componentRef: this.suggestionFocusZoneRef }, suggestedOptions.map(function (option, index) { return (React.createElement(OptionSearchSuggestion_1.default, { key: option.key, option: option, onKeyDown: _this.onFirstOptionKeyDown, "data-option-index": index })); }))))));
    };
    FullOptionSearch = tslib_1.__decorate([
        mobx_react_1.observer
    ], FullOptionSearch);
    return FullOptionSearch;
}(React.Component));
exports.default = FullOptionSearch;
//# sourceMappingURL=FullOptionSearch.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/FullOptionSearch.js
// module id = 5287
// module chunks = 2